export default __webpack_public_path__ + "static/media/heart.933f4ed6.svg";